import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import logoIzquierdo from '@/assets/logo_durango.png'
import logoDerecho from '@/assets/logo_salud.jpg'

function getBase64FromImage(imgUrl) {
    return new Promise((resolve) => {
        const img = new Image()
        img.crossOrigin = 'anonymous'
        img.onload = () => {
            const canvas = document.createElement('canvas')
            canvas.width = img.width
            canvas.height = img.height
            const ctx = canvas.getContext('2d')
            ctx.drawImage(img, 0, 0)
            resolve(canvas.toDataURL('image/png'))
        }
        img.src = imgUrl
    })
}

function formatearFecha(fecha) {
    return new Intl.DateTimeFormat('es-MX', {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
    }).format(new Date(fecha))
}

function formatMayusculas(palabras) {
    return palabras.toUpperCase()
}

function formatearFechaHora(fecha) {
    return new Intl.DateTimeFormat('es-MX', {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    }).format(new Date(fecha))
}

// function campo(doc, label, value, x, y, width = 70) {
//   doc.setFontSize(8)
//   doc.setFont('helvetica', 'normal')
//   doc.text(label, x, y)
//   doc.setFontSize(9)

//   doc.setFont('helvetica', 'bold')
//   doc.text(value || '', x, y + 4)

//   doc.setDrawColor(0)
//   doc.line(x, y + 5, x + width, y + 5)
// }

function campo(doc, label, value, x, y, width = 70, minHeight = 10) {
    doc.setFontSize(8)
    doc.setTextColor('000')

    doc.setFont('helvetica', 'bold')
    doc.text(label, x, y)

    doc.setFontSize(9)
    doc.setFont('helvetica', 'normal')
    doc.setTextColor('000   ')

    const text = value || ''
    const textLines = doc.splitTextToSize(text, width - 4)
    const boxHeight = Math.max(minHeight, textLines.length * 4 + 2)

    // Caja gris SIN borde
    doc.setFillColor(245, 245, 245)
    doc.rect(x, y + 1, width, boxHeight, 'F')

    // Texto dentro
    doc.text(textLines, x + 2, y + 5)

     // 🔥 Borde inferior delgado
  doc.setDrawColor(208, 208, 208)      // gris elegante
  doc.setLineWidth(0.3)
  doc.line(x, y +1 + boxHeight, x + width, y+1 + boxHeight)

    return y + boxHeight + 8
}


function tituloSeccion(doc, texto, y) {
    doc.setFontSize(10)
    doc.setFont('helvetica', 'bold')
    doc.setTextColor(0)
    doc.text(texto.toUpperCase(), 14, y)

    doc.setDrawColor(0)
    doc.setLineWidth(0.6)
    doc.line(14, y + 2, 200, y + 2)

    return y + 8
}

async function generarVisitaDomiciliaria(paciente) {
    const doc = new jsPDF('p', 'mm', 'letter')
    const pageWidth = doc.internal.pageSize.getWidth()


    const logo1 = await getBase64FromImage(logoIzquierdo)
    const logo2 = await getBase64FromImage(logoDerecho)


    // Logo izquierdo
    doc.addImage(logo1, 'PNG', 15, 5, 45, 30)

    // Logo derecho
    doc.addImage(logo2, 'PNG', pageWidth - 60, 5, 45, 30)

    doc.setFontSize(12)
    doc.setFont('helvetica', 'bold')
    doc.text('REPORTE DE VISITA DOMICILIARIA', pageWidth / 2, 30, { align: 'center' })



    let y = 45
    y = campo(doc, 'Nombre del paciente:', 'JAVIER PEREZ REYES', 15, y, 185, 6)

    campo(doc, 'Edad:', '5 años, 3 meses y 20 dias', 15, y, 55, 6)
    campo(doc, 'Sexo:', 'JAVIER PEREZ REYES', 75, y, 65, 6)
    y = campo(doc, 'Estado Civil:', 'JAVIER PEREZ REYES', 145, y, 55, 6)
    y = campo(doc, 'GRADO DE ESTUDIOS:', 'JAVIER PEREZ REYES', 15, y, 185, 6)

    y = campo(doc, 'DOMICILIO', 'Dar contestación a las solicitudes de Acceso a la Información .', 14, y, 185, 6)
    y = campo(doc, 'LOCALIDAD', 'Dar contestación a las solicitudes de Acceso a la Información .', 14, y, 185, 6)
    y = campo(doc, 'MOTIVO DE LA VISITA', 'Dar contestación a las solicitudes de Acceso a la Información a través de la Plataforma Nacional de Transparencia, con la colaboración de la información proporcionada por las diversas áreas de los Servicios de Salud del Estado de Durango.', 14, y, 185)
    y = campo(doc, 'PROGRAMA:', 'BRIGADAS CON VALOR, ATENCIÓN POSTQUIRÚRGICA', 15, y, 185, 6)
    y = campo(doc, 'RESULTADO:', 'Dar contestación a las solicitudes de Acceso a la Información a través de la Plataforma Nacional de Transparencia, con la colaboración de la información proporcionada por las diversas áreas de los Servicios de Salud del Estado de Durango.', 14, y, 185)
    y = campo(doc, 'OBSERVACIONES:', 'Dar contestación a las solicitudes de Acceso a la Información a través de la Plataforma Nacional de Transparencia, con la colaboración de la información proporcionada por las diversas áreas de los Servicios de Salud del Estado de Durango.', 14, y, 185)
    y = campo(doc, 'HORA DE LLEGADA:', 'JAVIER PEREZ REYES', 145, y, 55, 6)


    const lineaY = y 
        doc.text('NOMBRE Y FIRMA DEL ENTREVISTADO', pageWidth / 4, lineaY + 5, { align: 'center' })

        doc.line(pageWidth / 4 - 30, lineaY + 20, pageWidth / 4 + 30, lineaY + 20) // línea horizontal
        doc.text(formatMayusculas('MI MOBRE'), pageWidth / 4, lineaY + 25, { align: 'center' })
        doc.text('JAVIER PEREZ REYES', pageWidth / 4, lineaY + 30, { align: 'center' })

        // Firma 2 (derecha)

        doc.text('NOMBRE Y FIRMA DEL ENFERMERO', (pageWidth / 4 + pageWidth / 2), lineaY + 5, { align: 'center' })

        doc.line((pageWidth / 4 + pageWidth / 2) - 30, lineaY + 20, (pageWidth / 4 + pageWidth / 2) + 30, lineaY + 20)
        doc.text(formatMayusculas('JAVIER PEREZ REYES'), (pageWidth / 4 + pageWidth / 2), lineaY + 25, { align: 'center' })
        doc.text('2418418418181', (pageWidth / 4 + pageWidth / 2), lineaY + 30, { align: 'center' })

    // if (y + 40 > doc.internal.pageSize.height) {
    //   doc.addPage()
    //   y = 20
    // }

    doc.save('VisitaDomiciliaria.pdf')
}
export { generarVisitaDomiciliaria }